import React, {useState, useEffect}from 'react'
import "./css/Rally.css"
//redux stuff
import { useSelector, useDispatch} from 'react-redux';
import {setRallyNumber,setBestRally} from "./redux/rallyTracker"

//firebase stuff
import {firebase} from './firebase';
import {collectionRef, db} from './firebase';
import { addDoc,deleteDoc, doc, getDocs, collection, query, where,serverTimestamp, getDoc } from 'firebase/firestore';
import {getAuth, createUserWithEmailAndPassword,signOut,signInWithEmailAndPassword,updateProfile} from 'firebase/auth';
import { render } from '@testing-library/react';

const RallyGetDataFromDB = React.memo(props => {
     const auth = getAuth();
     const [loading, setLoading] = useState(false);

     //redux
     let dispatch = useDispatch();
     const reduxUserID = useSelector((state) => state.isLoggedIn.reduxUserID);
     const reduxRallyNumber = useSelector((state) => state.rallyTracker.reduxRallyNumber);

     //create the DB paths to put the data into
     const rallyRef = collection(db,"users",reduxUserID,"rally");

     
     useEffect(() => {
          //call this in useEffect but we were getting a render, creating two documents for the rally number
          getRallyData();
          
     }, [reduxUserID])

     const getRallyData = () => {
          setLoading(true);

          const documents = getDocs(rallyRef)
          .then((snapshot)=>{
              var dataGrab = new Array(); //which becomes an object for some reason
              snapshot.docs.forEach((doc)=>{
                  dataGrab.push({...doc.data(),id:doc.id})
                  console.log('GETDATA -- reduxUserID: ' + reduxUserID);
              })
              const dbDataARRAY = Object.values(dataGrab); // Object.values() converts it to an array()

              //if theyre brand new, check if theres a rally number in their user DB. if not, set state to zero
              //else, set the state to whatever number is returned
              if(dbDataARRAY.length == 0){
               //
               addDoc(rallyRef,{
                    rallyNumber: 0,
                    bestRally: 0
                  }).then(() => {
                    //redux version
                    dispatch(setRallyNumber(0));
                    dispatch(setBestRally(0));
                    setLoading(false);
                  });
              }
              else{
                    //redux - grab 
                    dispatch(setRallyNumber(dbDataARRAY[0].rallyNumber));
                    dispatch(setBestRally(dbDataARRAY[0].bestRally));
                    setLoading(false);
              }
             
          })//end then()
        }////end getRallyData()

      

        
     return (
          <div className=''>

          </div>
     )
})

export default RallyGetDataFromDB
